// 支付平台开通状态
export enum WalletActivationStatus {
  notOpen = 0, //未开通
  openSuccess = 1, //开通成功
}
export enum PayCodeStatus {
  unnamed = 4100011, //未实名code
  invalidOrder = 3600000, //求购订单已失效
  inconformity = 3600007, // 收款钱包与求购这付款钱包不一致，请开通并勾选全部收款账户再试一次
  captchaErrorCode = 406, //滑块验证错误code
  smsErrorCode = 400, //短信验证错误code
}
/**
 * 钱包是否被禁用
 */
export enum ProhibitUseWalletType {
  enable, //不禁用
  disable, //禁用
}
/**
 * 钱包列表
 */
export enum WalletType {
  lian = 25, //c
  join = 27, //d
  chinagpay = 29, //e
  aWallet = 23, //a
  bWallet = 24, //b
}
